import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const STEPS = [{
  num: '1',
  title: 'Diagnóstico',
  desc: 'Relevamiento integral del contexto normativo, político e institucional. Identificación de riesgos, oportunidades y actores clave.'
}, {
  num: '2',
  title: 'Priorización y Escenarios',
  desc: 'Construcción de escenarios, evaluación de impacto y definición de prioridades estratégicas con criterio ejecutivo.'
}, {
  num: '3',
  title: 'Estrategia y Relacionamiento',
  desc: 'Diseño de la hoja de ruta, articulación con stakeholders y construcción de coaliciones o posiciones institucionales.'
}, {
  num: '4',
  title: 'Ejecución y Seguimiento',
  desc: 'Implementación coordinada, monitoreo de resultados, ajuste continuo y reporte de contribución e impacto.'
}];
export function ComoTrabajamos() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.2
  });
  return <section id="como-trabajamos" className="py-10 md:py-14 bg-white overflow-hidden" data-id="element-35">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-36">
        <div className="mb-8 md:mb-10" data-id="element-37">
          <span className="font-body text-xs uppercase tracking-widest text-silver-dark mb-3 block" data-id="element-38">
            Cómo trabajamos
          </span>
          <h2 className="font-heading text-4xl md:text-5xl text-petrol-dark" data-id="element-39">
            Proceso
          </h2>
        </div>

        <div ref={ref} className={`relative scroll-animate ${isVisible ? 'is-visible' : ''}`} data-id="element-40">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-[28px] left-[40px] right-[calc(25%+40px)] h-px bg-silver-main/50 z-0" data-id="element-41"></div>

          {/* Connecting Line (Mobile) */}
          <div className="md:hidden absolute top-[40px] bottom-[40px] left-[28px] w-px bg-silver-main/50 z-0" data-id="element-42"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-5 relative z-10" data-id="element-43">
            {STEPS.map(step => <div key={step.num} className="flex flex-row md:flex-col items-start gap-5 md:gap-6" data-id="element-44">
                {/* Number Circle */}
                <div className="flex-shrink-0 w-14 h-14 rounded-full bg-white border-2 border-transparent bg-clip-padding relative flex items-center justify-center shadow-sm" data-id="element-45">
                  <div className="absolute inset-[-2px] rounded-full bg-petrol-gradient z-[-1]" data-id="element-46"></div>
                  <div className="absolute inset-0 rounded-full bg-white z-0" data-id="element-47"></div>
                  <span className="relative z-10 font-heading text-2xl text-petrol-dark font-semibold" data-id="element-48">
                    {step.num}
                  </span>
                </div>

                {/* Content */}
                <div className="pt-1 md:pt-0" data-id="element-49">
                  <h3 className="font-body font-semibold text-lg text-petrol-dark mb-2" data-id="element-50">
                    {step.title}
                  </h3>
                  <p className="font-body text-sm text-gray-600 leading-relaxed pr-4" data-id="element-51">
                    {step.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}